import React, { createContext, FC, PropsWithChildren } from 'react'

export const TranslateContext = createContext<ITranslateContext>({
  t: () => '',
})

const formatTranslateValue = (v: string, options: TOptions | undefined) => {
  if (!options) {
    return v
  }

  const optionsKeys = Object.keys(options)

  if (optionsKeys.length === 0) {
    return v
  }

  const formattedValue = optionsKeys.reduce((acc, key) => {
    const optionsValue = options[key]

    return acc.replace(`{{${key}}}`, optionsValue)
  }, v)

  return formattedValue
}

const TranslateProvider: FC<PropsWithChildren<ITranslateProvider>> = ({ translate, children }) => {
  const t: TFunction = (v, options) => {
    if (!translate || !translate[v]) {
      return v
    }

    return formatTranslateValue(translate[v], options)
  }

  return <TranslateContext.Provider value={{ t }}>{children}</TranslateContext.Provider>
}

export default TranslateProvider

interface ITranslateContext {
  t: TFunction
}

interface ITranslateProvider {
  translate: { [key: string]: string } | null | undefined
}

export type TFunction = (v: string, options?: TOptions) => string

interface TOptions {
  [key: string]: string
}
